export default "__VITE_ASSET__B3GS$tW8__"